import { useEffect } from "react"
import { useDispatch } from "react-redux"

import TabHeader from "../../tab/TabHeader"
import NotesComponent from "../notes/NotesComponent"
import LiabilityTabControls from "./LiabilityTabControls"
import LiabilityDetails from "./LiabilityDetails"
import { insuranceActions } from "../../../../store/insurance"
import ItemsCounter from "../Shared/ItemsCounter"

const LiabilityTab = ({ inWorkQ }) => {

    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(insuranceActions.setSearchResult(null))
            dispatch(insuranceActions.setClearAsyncResults(false))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Liability</h2>
                <ItemsCounter type={'liabilities'}/>
                <NotesComponent noteTypeId={3} inWorkQ={inWorkQ}/>
            </div>
            <LiabilityTabControls folder={'liabilities'} apiCase={'case_liability'}/>
        </TabHeader>
        <div>
            <LiabilityDetails />
        </div>
    </>
}

export default LiabilityTab